define('models/merchants/businesshours/businesshour',['backbone'
], function (Backbone) {
    var BusinessHour = Backbone.Model.extend({
        url: function () {
            return pf.merchantsURL + "/BusinessHour";
        },
        defaults:{
            DayOfWeek: "",
            OpenTime: "",
            CloseTime: "",
            PauseStartTime: "",
            PauseEndTime: "",
        },
        initialize: function (options) {
            options || (options = {});

            this.MerchantID = options.MID;
            this.BusinessHoursID = options.BHID;
            this.BusinessHoursExceptionID = options.BEID;
            this.OpenTime = options.OT;
            this.CloseTime = options.CT;
            this.DayOfWeek = options.DOW;
            this.DayOfWeekID = options.DID;
            this.PauseStartTime = options.PST;
            this.PauseEndTime = options.PET;
            this.IsException = options.ISE;
            if (options.EXD) {
                this.ExceptionDate = Date.parse(options.EXD);
                this.ExceptionDate = ((this.ExceptionDate.getMonth() + 1) < 10 ? "0" + (this.ExceptionDate.getMonth() + 1) : (this.ExceptionDate.getMonth() + 1)) + "-"
                                       + (this.ExceptionDate.getDate() < 10 ? "0" + this.ExceptionDate.getDate() : this.ExceptionDate.getDate()) + "-"
                                       + this.ExceptionDate.getFullYear();
            }
            this.Notes = options.NT;
            this.IsClosed = options.IMC;

        },
        parse: function (data) {
            var response = {};

            response.MerchantID = data.MID;
            response.BusinessHoursID = data.BHID;
            response.BusinessHoursExceptionID = data.BEID;
            response.OpenTime = data.OT;
            response.CloseTime = data.CT;
            response.PauseStartTime = data.PST;
            response.PauseEndTime = data.PET;
            response.DayOfWeek = data.DOW;
            response.DayOfWeekID = data.DID;
            response.IsException = data.ISE;
            if (data.EXD){
                response.ExceptionDate = Date.parse(data.EXD);
                response.ExceptionDate = ((response.ExceptionDate.getMonth() + 1) < 10 ? "0" + (response.ExceptionDate.getMonth() + 1) : (response.ExceptionDate.getMonth() +1))+ "-"
                                        + (response.ExceptionDate.getDate() < 10 ? "0" + response.ExceptionDate.getDate() : response.ExceptionDate.getDate()) + "-"
                                        + response.ExceptionDate.getFullYear();
            }
            response.Notes = data.NT;
            response.IsClosed = data.IMC;

            return response;
        },
        save: function (attributes, options) {
            options = options || {};
            attributes = attributes || {};

            var data = {};
            
            data.MID = this.attributes.MerchantID;
            data.BHID = this.attributes.BusinessHoursID;
            data.BEID = this.attributes.BusinessHoursExceptionID;
            data.OT = this.attributes.OpenTime;
            data.CT = this.attributes.CloseTime;
            data.PST = this.attributes.PauseStartTime;
            data.PET = this.attributes.PauseEndTime;
            data.DOW = this.attributes.DayOfWeek;
            data.DID = this.attributes.DayOfWeekID;
            data.ISE = this.attributes.IsException;
            data.EXD = this.attributes.ExceptionDate;
            data.NT = this.attributes.Notes;

            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, attributes, options, { validate: true });
        }        
    });

    return BusinessHour;
});

